/*eslint-disable */

import {
  bus
} from '@/main';
import {
  mapGetters
} from 'vuex';
import videoSocketRef from "@/videoNotificationSocket";

const $ = window.jQuery = require('jquery');
export default {
  name: 'forward-msg-popup',
  components: {},
  props: ['forwardMsgInfo', 'userInfo', 'chatRoomInfo'],
  data () {
    return {
      normalViewUserChatList:true,
      searchEnabled:false,
      search_term:'',
      allUserData:null,
      allUserDataResults:[],
      selfUserId:'',
      forwardMsgToSelctedUserInfo:[],
      forwardMsgToSelctedUserId:[],
      checkbox:'',
      submitted:false,
      sendNewRoomIdForMsg:'',
      pinnedChatRoomList:[],
      totalChatListOfData:null,
      totalChatListOfArray: [],
      totalChatListOfLoadMore:''
    }
  },
  computed: {
    ...mapGetters([
      'getAllUserChatListMBLGetters',
      'getChatRoomPinnedListGetters'
    ]),
    getPinnedRoomChatListFun() {
      this.pinnedChatRoomList = this.$store.getters.getChatRoomPinnedListGetters.data
      return
    },
    getAllRoomChatListFun() {
      this.totalChatListOfData = this.$store.getters.getAllUserChatListMBLGetters.data
      return
    },
    setIntailStateOfChatListFun(){
      if(this.totalChatListOfData){
        this.totalChatListOfArray = this.totalChatListOfData.results
        this.totalChatListOfLoadMore = this.totalChatListOfData.next
      }
      return
    }
  },
  mounted () {
    this.getPinnedRoomChatListFun
    this.getAllRoomChatListFun
    this.setIntailStateOfChatListFun
    this.selfUserId = this.userInfo.id
  },
  methods: {
    searchEnabledMethod(){
      this.searchEnabled = true
    },
    searchBarForChatClosedFun(){
      this.searchEnabled = false
      this.search_term = ''
      this.normalViewUserChatList = true
    },
    clearAllSearchKeywormethod(){
      this.searchEnabled = false
      this.search_term = ''
      this.normalViewUserChatList = true
    },
    onChangeSearchUser(){
      if(this.search_term.length >= 3){
        var searchListTimeOut = setTimeout(()=>{
          this.$store.dispatch('seachUserOfChatInWorkspaceAction', { query: this.search_term }).then((response) => {
            this.normalViewUserChatList = false
            this.allUserDataResults = response.data.data
          })
          clearTimeout(searchListTimeOut)
       },1000)
      }else{
        this.normalViewUserChatList = true
      }
    },
    forwardMsgPopupClosed(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('forwardMsgPopupBus', false);
    },
    getChatRoomIdMethod(info){
      this.forwardMsgToSelctedUserId= []
      info.map((item) => {
        this.forwardMsgToSelctedUserId.push(item.chat_room)
      })
      return  this.forwardMsgToSelctedUserId;
    },
    forwardMsgToSelctedUserMethod() {
      let sendMsgId;
      let sendMsgTxt;
      if(this.forwardMsgInfo.id){
        sendMsgId = this.forwardMsgInfo.id
        sendMsgTxt = this.forwardMsgInfo.message
      }else{
        sendMsgId = this.forwardMsgInfo.chat_data.message_id
        sendMsgTxt = this.forwardMsgInfo.chat_data.message
      }
      let sentData = {
        'message': sendMsgTxt,
        type: 'sent',
        selfUserID: this.selfUserId,
        user_id: this.selfUserId,
        is_read: false,
        name:this.userInfo.first_name + ' ' + this.userInfo.last_name,
        message_id:sendMsgId
        // filename:this.forwardMsgInfo.data.filename || ''
      }
      var roomId = this.getChatRoomIdMethod(this.forwardMsgToSelctedUserInfo)
       let data = {
        chat_room_users:roomId,
        message : sendMsgTxt,
        chat_data:sentData,
        forwarded:true,
        message_id:sendMsgId
       }
       this.submitted = true 
       this.$store.dispatch('forwardMessageToUsersFun', data).then((res) => {
        if(videoSocketRef.isOpen()){
          videoSocketRef.emit({
            type: "forward_message",
            toUserID:this.selfUserId,
            targetUsersID:roomId,
            second_user_id:roomId,
            chat_data:res.data.data.chat_data,
            forwarded:true,
            colour:res.data.data.colour_arr[0],
            message_id_arr:res.data.data.message_id_arr
          });
        }    
        this.$store.dispatch('getChatRoomPinnedListFun').then((res) => {
          this.$store.dispatch('getAllLeftChatListDetailsFun').then((res) => {
            $('.chat_user_listed').first().addClass('active');
            document.querySelector('.chat_user_listed.active .chats_tab_name').click()
            this.submitted = false
            this.forwardMsgPopupClosed()
          }).catch((err)=>{
          })
        }).catch((err)=>{})
       }).catch((err) => {this.submitted = false})
    }
  },
  watch:{
    getPinnedRoomChatListFun() {
      return this.$store.getters.getChatRoomPinnedListGetters.data
    },
    getAllRoomChatListFun() {
      return this.$store.getters.getAllUserChatListMBLGetters
    },
    setIntailStateOfChatListFun(){
      if(this.totalChatListOfData){
        this.totalChatListOfArray = this.totalChatListOfData.results
        this.totalChatListOfLoadMore = this.totalChatListOfData.next
      }
      return
    }
  }
}


